import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { QUESTION_ANSWER, QUESTION_ANSWER_HOTEL, QUESTION_ANSWER_TRAVEL } from '../Constants/FAQs';

function FAQTabs({ activeKey }) {
    return (
        <Accordion defaultActiveKey="0">
            {QUESTION_ANSWER[activeKey]?.map((item, index) => (
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{item.question}</Accordion.Header>
                    <Accordion.Body className='accordian-collapse-chev'>{item.answer}</Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
}

export function FAQHotel() {
    return (
        <Accordion defaultActiveKey="0">
            {QUESTION_ANSWER_HOTEL.map((item, index) => (
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{item.question}</Accordion.Header>
                    <Accordion.Body className='accordian-collapse-chev'>{item.answer}</Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
}

export function FAQTravel() {
    return (
        <Accordion defaultActiveKey="0">
            {QUESTION_ANSWER_TRAVEL.map((item, index) => (
                <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{item.question}</Accordion.Header>
                    <Accordion.Body className='accordian-collapse-chev'>{item.answer}</Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
}

export default FAQTabs;